import React, { Component } from "react";
import { connect } from "react-redux";
import WithRoutify from "../../../hoc/WithRoutify";
import WithRouter from "../../../hoc/WithRouter";
import IncidentList from "../../IncidentContainer/IncidentList";
import { decryptString } from "../../../utils/commonUtils";

class IncidentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Add any default state properties here if needed
    };
  }

  componentDidMount() {
    // Add any initialization logic here
  }

  componentDidUpdate(prevProps) {
    // Add any logic you want to execute when props are updated
  }

  componentWillUnmount() {
    // Add any cleanup logic when the component is about to unmount
  }

  render() {
    const { params, patientDetails } = this.props;
    const decryptedPatientDetails = patientDetails || (params?.patientDetails ? decryptString(params.patientDetails) : {});

    return (
      <div id="home" className="tab-pane active show" role="tabpanel">
        <div className="sh_innerPortview">
          <div className="p-2">
            <div className="sh_cardBox sh_chartboxht shadow-none border">
              <div className="sh_cardHeader">
                <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                  <h6 className="text-sm mb-0">
                    Incidents - {decryptedPatientDetails.patientName || 'Patient'}
                  </h6>
                </div>
              </div>

              <IncidentList
                {...this.props}
                isFromVisitHistory={true}
                patientDetails={decryptedPatientDetails}
                employeeId={params?.patientId}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Map Redux state to props
const mapStateToProps = (state) => ({
  isNewUI: state.common.isNewUI,
});

export default connect(mapStateToProps)(
  WithRouter(WithRoutify(IncidentsList))
);
